/**
 * Card brands supported by our system. These try to match the Stripe card brand values for simplicity.
 */
export var CardBrand;
(function (CardBrand) {
    CardBrand["Visa"] = "Visa";
    CardBrand["AmericanExpress"] = "American Express";
    CardBrand["MasterCard"] = "MasterCard";
    CardBrand["Discover"] = "Discover";
    CardBrand["JCB"] = "JCB";
    CardBrand["DinersClub"] = "Diners Club";
    CardBrand["Unknown"] = "Unknown";
})(CardBrand || (CardBrand = {}));
